<template>
  <div>
    <v-row data-test="readonly-requirements" align="center">
      <v-col class="shrink pr-2">
        <v-icon>navigation</v-icon>
      </v-col>
      <v-col class="grow">
        <vs-text>{{ resourceType }} — Not assigned yet </vs-text>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ resourceTypeName?: string }>()
const resourceType = computed(() => props.resourceTypeName ?? '')
</script>

<style scoped>
.v-icon {
  font-family: 'Material Icons Outlined';
  color: var(--color-grey);
}
</style>
